import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { Fragment } from 'react';

export enum VehicleIdentification {
    BADGE = 'BADGE',
    LICENSE_PLATE = 'LICENSE_PLATE',
    QR = 'QR',
}

export enum ParkingaboCustomerPaymentMode {
    COUNTER = 'COUNTER',
    INDIVIDUAL_PAYMENT = 'INDIVIDUAL_PAYMENT',
    APP_PAYMENT = 'APP_PAYMENT',
}

export interface ParkingaboOperatingMode {
    operatingModeId: number;
    vehicleIdentification: VehicleIdentification[];
    paymentMode: ParkingaboCustomerPaymentMode;
    deactivated: boolean;
}

export function OperatingModeText({
    vehicleIdentification,
    paymentMode,
}: {
    vehicleIdentification: VehicleIdentification[];
    paymentMode: ParkingaboCustomerPaymentMode;
}) {
    return (
        <>
            {vehicleIdentification.map((vehicleIdentification, index) => (
                <Fragment key={vehicleIdentification}>
                    {index > 0 && <Localized de=", " fr=", " it=", " en=", " />}
                    <VehicleIdentificationText
                        vehicleIdentification={vehicleIdentification}
                    />
                </Fragment>
            ))}
            <Localized de=" mit " fr=" avec " it=" con " en=" with " />
            <PaymentModeText paymentMode={paymentMode} />
        </>
    );
}

export function VehicleIdentificationText({
    vehicleIdentification,
}: {
    vehicleIdentification: VehicleIdentification;
}) {
    switch (vehicleIdentification) {
        case VehicleIdentification.BADGE:
            return <Localized de="Badge" fr="Badge" it="Badge" en="Badge" />;
        case VehicleIdentification.LICENSE_PLATE:
            return (
                <Localized
                    de="Kennzeichen"
                    fr="Immatriculation"
                    it="Targa"
                    en="License plate"
                />
            );
        case VehicleIdentification.QR:
            return (
                <Localized
                    de="QR-Code"
                    fr="Code QR"
                    it="Codice QR"
                    en="QR code"
                />
            );
    }
}

export function PaymentModeText({
    paymentMode,
}: {
    paymentMode: ParkingaboCustomerPaymentMode;
}) {
    switch (paymentMode) {
        case ParkingaboCustomerPaymentMode.COUNTER:
            return (
                <Localized
                    de="Schalter"
                    fr="Guichet"
                    it="Sportello"
                    en="Counter"
                />
            );
        case ParkingaboCustomerPaymentMode.INDIVIDUAL_PAYMENT:
            return (
                <Localized
                    de="Einzelzahlung"
                    fr="Paiement individuel"
                    it="Pagamento singolo"
                    en="Individual payment"
                />
            );
        case ParkingaboCustomerPaymentMode.APP_PAYMENT:
            return (
                <Localized
                    de="App-Zahlung"
                    fr="Paiement app"
                    it="Pagamento app"
                    en="App payment"
                />
            );
    }
}
